/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Switch } from "@mui/material";
import { Column } from "../../../../interfaces/table";
import { useNavigate } from "react-router";
import { IMeta } from "../../../../interfaces/common";
import { globalOnPageChange } from "../../../../Admin-Dashboard/helpers/on-page-change.helper";
import { globalOnSetFilters } from "../../../../Admin-Dashboard/helpers/on-set-filters.helper";
import { globalOnApplyFilters } from "../../../../Admin-Dashboard/helpers/on-apply-filters.helper";
import { globalOnClear } from "../../../../Admin-Dashboard/helpers/on-clear.helper";
import { globalOnSortAction } from "../../../../Admin-Dashboard/helpers/onFilterAction";
import { useSelector } from "react-redux";

import { RootState } from "../../../../store/store";
import { IGetStateParams } from "../../../../Admin-Dashboard/interfaces/state.bike24.interface";
import {
  getPreferences,
  updatePreferencesForId,
} from "../../../../Admin-Dashboard/apiHandler/preference.service";

const usePreferences = () => {
  const navigation = useNavigate();
  const sideBarAccess = useSelector((data: RootState) => data.sideBarAccess);
  const [rows, updateRows] = useState<any[]>([]);
  const [filters, setFilters] = useState<IGetStateParams>({});
  const [page, setPage] = useState(1);
  const [metaInfo, setMetaInfo] = useState<IMeta | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [logModalInfoProp, setLogModalInfoProp] = useState<{
    name: string;
    id: number;
  } | null>(null);
  const hasEditAccess =
    sideBarAccess.accessData.collections?.["bike_state"]?.create;
  const hasCreateAccess =
    sideBarAccess.accessData.collections?.["bike_state"]?.update;
  useEffect(() => {
    let params = {
      ...filters,
      page,
    };
    getAwardApiCall(params);
  }, []);

  const columns: Column[] = [
    {
      id: "id",
      label: "Id",
      minWidth: 170,
      align: "center",
      key: "id",
      isSortable: false,
    },

    {
      id: "name",
      label: "Name",
      minWidth: 170,
      align: "center",
      key: "name",
      isSortable: false,
    },
 
    {
      id: "actions",
      label: "Whatsapp notification",
      minWidth: 100,
      align: "center",
      key: "actions",
      isSortable: false,
      render: (_, row: any) => {
        return (
          <div className="flex justify-center items-center gap-2">
            <Switch
              disabled={true}
              onChange={async () => {
                const data = {
                  enableAll: {
                    value: row?.preferences?.enableAll,
                    source: "User Update",
                  },
                  whatsappMessages: {
                    value: !row?.preferences?.whatsappMessages,
                    source: "User Update",
                  },
                  smsNotifications: {
                    value: row?.preferences?.smsNotifications,
                    source: "User Update",
                  },
                  emailNotifications: {
                    value: row?.preferences?.emailNotifications,
                    source: "User Update",
                  },
                  pushNotifications: {
                    value: row?.preferences?.pushNotifications,
                    source: "User Update",
                  },
                  rcsNotifications: {
                    value: row?.preferences?.rcsNotifications,
                    source: "User Update",
                  },
                  calls: {
                    value: row?.preferences?.calls,
                    source: "User Update",
                  },
                };

                await updatePreferencesForId(row.id,data);
                const newRows: any[] = [...rows].map((item: any) =>
                  item.id === row.id
                    ? {
                        ...item,
                        preferences: {
                          ...item.preferences,
                          whatsappMessages: !item.preferences.whatsappMessages,
                        },
                      }
                    : { ...item }
                );
                updateRows(newRows);
              }}
              checked={row?.preferences?.whatsappMessages}
            />
          </div>
        );
      },
    },
    {
      id: "actions",
      label: "Sms Notifications",
      minWidth: 100,
      align: "center",
      key: "actions",
      isSortable: false,
      render: (_, row: any) => {
        return (
          <div className="flex justify-center items-center gap-2">
            <Switch
              disabled
              onChange={async () => {
                const data = {
                  enableAll: {
                    value: row?.preferences?.enableAll,
                    source: "User Update",
                  },
                  whatsappMessages: {
                    value: row?.preferences?.whatsappMessages,
                    source: "User Update",
                  },
                  smsNotifications: {
                    value: !row?.preferences?.smsNotifications,
                    source: "User Update",
                  },
                  emailNotifications: {
                    value: row?.preferences?.emailNotifications,
                    source: "User Update",
                  },
                  pushNotifications: {
                    value: row?.preferences?.pushNotifications,
                    source: "User Update",
                  },
                  rcsNotifications: {
                    value: row?.preferences?.rcsNotifications,
                    source: "User Update",
                  },
                  calls: {
                    value: row?.preferences?.calls,
                    source: "User Update",
                  },
                };

                await updatePreferencesForId(row.id,data);
                const newRows: any[] = [...rows].map((item: any) =>
                  item.id === row.id
                    ? {
                        ...item,
                        preferences: {
                          ...item.preferences,
                          smsNotifications: !item.preferences.smsNotifications,
                        },
                      }
                    : { ...item }
                );
                updateRows(newRows);
              }}
              checked={row?.preferences?.smsNotifications}
            />
          </div>
        );
      },
    },
    {
      id: "actions",
      label: "Email notifications",
      minWidth: 100,
      align: "center",
      key: "actions",
      isSortable: false,
      render: (_, row: any) => {
        return (
          <div className="flex justify-center items-center gap-2">
            <Switch
              disabled
              onChange={async () => {
                const data = {
                  enableAll: {
                    value: row?.preferences?.enableAll,
                    source: "User Update",
                  },
                  whatsappMessages: {
                    value: row?.preferences?.whatsappMessages,
                    source: "User Update",
                  },
                  smsNotifications: {
                    value: row?.preferences?.smsNotifications,
                    source: "User Update",
                  },
                  emailNotifications: {
                    value: !row?.preferences?.emailNotifications,
                    source: "User Update",
                  },
                  pushNotifications: {
                    value: row?.preferences?.pushNotifications,
                    source: "User Update",
                  },
                  rcsNotifications: {
                    value: row?.preferences?.rcsNotifications,
                    source: "User Update",
                  },
                  calls: {
                    value: row?.preferences?.calls,
                    source: "User Update",
                  },
                };

                await updatePreferencesForId(row.id,data);
                const newRows: any[] = [...rows].map((item: any) =>
                  item.id === row.id
                    ? {
                        ...item,
                        preferences: {
                          ...item.preferences,
                          emailNotifications: !item.preferences.emailNotifications,
                        },
                      }
                    : { ...item }
                );
                updateRows(newRows);
              }}
              checked={row?.preferences?.emailNotifications}
            />
          </div>
        );
      },
    },
    {
      id: "actions",
      label: "Push notifications",
      minWidth: 100,
      align: "center",
      key: "actions",
      isSortable: false,
      render: (_, row: any) => {
        return (
          <div className="flex justify-center items-center gap-2">
            <Switch
              disabled
              onChange={async () => {
                const data = {
                  enableAll: {
                    value: row?.preferences?.enableAll,
                    source: "User Update",
                  },
                  whatsappMessages: {
                    value: row?.preferences?.whatsappMessages,
                    source: "User Update",
                  },
                  smsNotifications: {
                    value: row?.preferences?.smsNotifications,
                    source: "User Update",
                  },
                  emailNotifications: {
                    value: row?.preferences?.emailNotifications,
                    source: "User Update",
                  },
                  pushNotifications: {
                    value: !row?.preferences?.pushNotifications,
                    source: "User Update",
                  },
                  rcsNotifications: {
                    value: row?.preferences?.rcsNotifications,
                    source: "User Update",
                  },
                  calls: {
                    value: row?.preferences?.calls,
                    source: "User Update",
                  },
                };

                await updatePreferencesForId(row.id,data);
                const newRows: any[] = [...rows].map((item: any) =>
                  item.id === row.id
                    ? {
                        ...item,
                        preferences: {
                          ...item.preferences,
                          pushNotifications: !item.preferences.pushNotifications,
                        },
                      }
                    : { ...item }
                );
                updateRows(newRows);
              }}
              checked={row?.preferences?.pushNotifications}
            />
          </div>
        );
      },
    },
    {
      id: "actions",
      label: "Rcs notifications",
      minWidth: 100,
      align: "center",
      key: "actions",
      isSortable: false,
      render: (_, row: any) => {
        return (
          <div className="flex justify-center items-center gap-2">
            <Switch
              disabled
              onChange={async () => {
                const data = {
                  enableAll: {
                    value: row?.preferences?.enableAll,
                    source: "User Update",
                  },
                  whatsappMessages: {
                    value: row?.preferences?.whatsappMessages,
                    source: "User Update",
                  },
                  smsNotifications: {
                    value: row?.preferences?.smsNotifications,
                    source: "User Update",
                  },
                  emailNotifications: {
                    value: row?.preferences?.emailNotifications,
                    source: "User Update",
                  },
                  pushNotifications: {
                    value: row?.preferences?.pushNotifications,
                    source: "User Update",
                  },
                  rcsNotifications: {
                    value: !row?.preferences?.rcsNotifications,
                    source: "User Update",
                  },
                  calls: {
                    value: row?.preferences?.calls,
                    source: "User Update",
                  },
                };

                await updatePreferencesForId(row.id,data);
                const newRows: any[] = [...rows].map((item: any) =>
                  item.id === row.id
                    ? {
                        ...item,
                        preferences: {
                          ...item.preferences,
                          rcsNotifications: !item.preferences.rcsNotifications,
                        },
                      }
                    : { ...item }
                );
                updateRows(newRows);
              }}
              checked={row?.preferences?.rcsNotifications}
            />
          </div>
        );
      },
    },
    {
      id: "actions",
      label: "Calls",
      minWidth: 100,
      align: "center",
      key: "actions",
      isSortable: false,
      render: (_, row: any) => {
        return (
          <div className="flex justify-center items-center gap-2">
            <Switch
              disabled
              onChange={async () => {
                const data = {
                  enableAll: {
                    value: row?.preferences?.enableAll,
                    source: "User Update",
                  },
                  whatsappMessages: {
                    value: row?.preferences?.whatsappMessages,
                    source: "User Update",
                  },
                  smsNotifications: {
                    value: row?.preferences?.smsNotifications,
                    source: "User Update",
                  },
                  emailNotifications: {
                    value: row?.preferences?.emailNotifications,
                    source: "User Update",
                  },
                  pushNotifications: {
                    value: row?.preferences?.pushNotifications,
                    source: "User Update",
                  },
                  rcsNotifications: {
                    value: row?.preferences?.rcsNotifications,
                    source: "User Update",
                  },
                  calls: {
                    value: !row?.preferences?.calls,
                    source: "User Update",
                  },
                };

                await updatePreferencesForId(row.id,data);
                const newRows: any[] = [...rows].map((item: any) =>
                  item.id === row.id
                    ? {
                        ...item,
                        preferences: {
                          ...item.preferences,
                          calls: !item.preferences.calls,
                        },
                      }
                    : { ...item }
                );
                updateRows(newRows);
              }}
              checked={row?.preferences?.calls}
            />
          </div>
        );
      },
    },
  ];

  const onLogModalOpenClose = () => {
    setLogModalInfoProp(null);
    setLogModalOpen(false);
  };

  const formatData = (data: any) => {
    return {
      id: data.id,
      name: data.name,
      preferences: data?.preferences,
    };
  };
  const handleNewEntry = () => navigation("/bikes24-dashboard/state/new");
  const handleViewEntry = (row: any) => {
    if (row?.id && hasEditAccess) {
      navigation(`/bikes24-dashboard/state/${row.id}`);
    }
  };
  const getAwardApiCall = async (params: IGetStateParams) => {
    setIsLoading(true);
    await getPreferences(params).then((res) => {
      const modifiedRes = res?.data?.map((item: any) =>
        formatData({
          id: item?.pvtProductId,
          name: item?.name,
          preferences: item?.preferences,
        })
      );
      setMetaInfo(res?.meta);
      updateRows(modifiedRes);
    });
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };
  const filterStructure = [
    {
      type: "inputField",
      name: "id",
      label: "Id",
      key: "pvtProductId",
    },
    {
      type: "inputField",
      name: "Name",
      label: "Name",
      key: "name",
    },
    {
      type: "inputField",
      name: "mobileNumber",
      label: "Mobile Number",
      key: "mobileNumber",
    },
  ];

  const onSortAction = (orderBy: string | null, orderType: string | null) => {
    globalOnSortAction(
      setPage,
      getAwardApiCall,
      { ...filters },
      orderBy,
      orderType
    );
    globalOnSetFilters<IGetStateParams>(setFilters, "orderBy", orderBy);
    globalOnSetFilters<IGetStateParams>(setFilters, "orderType", orderType);
  };
  return {
    columns,
    rows,
    handleViewEntry,
    handleNewEntry,
    page,
    isLoading,
    onPageChange: (page: number) =>
      globalOnPageChange(page, setPage, getAwardApiCall, { ...filters }),
    metaInfo,
    filterStructure,
    onSetFilters: (key: any, value: any) =>
      globalOnSetFilters<IGetStateParams>(setFilters, key, value),
    filters,
    onApplyFilters: () =>
      globalOnApplyFilters(setPage, getAwardApiCall, { ...filters, page }, 1),
    onClear: () =>
      globalOnClear(setFilters, setPage, getAwardApiCall, filters, 1),
    onSortAction,
    onLogModalOpenClose,
    logModalOpen,
    logModalInfoProp,
    hasCreateAccess,
  };
};
export default usePreferences;
